import { render, staticRenderFns } from "./Repair.vue?vue&type=template&id=c146d264&"
import script from "./Repair.vue?vue&type=script&lang=ts&"
export * from "./Repair.vue?vue&type=script&lang=ts&"
import style0 from "./Repair.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports